import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TextToFind } from '@classes/wiki/text-to-find.model';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth/auth.service';
import { EditorService } from '@services/wiki/editor.service';
import { FileService } from '@services/wiki/file.service';
import { SearchedService } from '@services/wiki/searched.service';
import { UtilitiyService } from '@services/wiki/utility.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { Subscription } from 'rxjs';
import FileSaver from 'file-saver';
import { Role } from 'app/shared/models/enum/role.enum';
import { Project } from 'app/shared/models/enum/project.enum';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
  selector: 'app-wiki',
  templateUrl: './wiki.component.html',
  styleUrls: ['./wiki.component.scss']
})
export class WikiComponent extends SubscriptionBaseComponent implements OnInit {

  private editModeSub: Subscription;
  private fileSelectedSub: Subscription;
  private editorSub: Subscription;


  findTextForm: UntypedFormGroup;
  hasSelectedAFile: boolean;
  checked: boolean;
  languages: string[];
  selectedLanguage = 'fr';
  isInEditMode = false;
  titleBool = true;
  contentBool = true;
  isBizzDev = false;
  providerType = Project;
  selectedDirectoryOrFilePath: string;
  selectedDirectoryOrFileName: string;

  selectedProviderType: Project;

  mobileQuery: MediaQueryList;
  private mobileQueryListener: () => void;

  constructor(
    private fileService: FileService,
    private searchedService: SearchedService,
    private editorService: EditorService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private utilityService: UtilitiyService,
    private authService: AuthService,
    private media: MediaMatcher,
    private changeDetectorRef: ChangeDetectorRef) {
    super();
    this.mobileQuery = media.matchMedia('(max-width: 999px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
  }

  ngOnInit(): void {
    this.initPage();
  }

  onSubmit(): void {
    const lg = 'fr'; // this.authService.getDecodedToken().language;
    if (this.findTextForm.value.textToFind && (this.titleBool || this.contentBool)) {
      if (this.titleBool && this.contentBool) {
        this.searchForWord(new TextToFind(this.findTextForm.value.textToFind, lg, 'contentAndTitle'));
      } else {
        this.searchForWord(new TextToFind(this.findTextForm.value.textToFind, lg, this.titleBool ? 'title' : 'content'));
      }
      this.router.navigate(['/smartwaste/Wiki/search']);
    }
  }

  goToReorder(): void {
    this.router.navigate(['/smartwaste/Wiki/reorder']);
  }

  changeEditMode(event): void {
    this.editorService.changeEditMode(event.checked);
    sessionStorage.setItem(environment.editable, event.checked.toString());
  }

  changeSearchTitle(): void {
    this.contentBool = true;
  }

  changeSearchContent(): void {
    this.titleBool = true;
  }

  printToPdf(): void {
    this.editorService.printFile(this.selectedDirectoryOrFilePath, this.selectedProviderType).subscribe(data => {
      const fileName = `${this.utilityService.stripHtml(this.selectedDirectoryOrFileName)}.pdf`;
      const blob = new Blob([data], { type: 'application/pdf' });
      FileSaver.saveAs(blob, fileName);
    });
  }

  providerChange(): void {
    sessionStorage.setItem(environment.project, this.selectedProviderType);
    this.fileService.changeProviderSub(this.selectedProviderType);
    this.router.navigate(['/wiki']);
  }

  private initPage(): void {
    const token = this.authService.getDecodedToken();
    if (token.role.includes(Role.Administration$SuperAdmin)) {
      this.isBizzDev = true;
    }
    const pj = sessionStorage.getItem(environment.project);
    this.selectedProviderType = (pj !== null && pj !== undefined && pj !== '')
      ? pj as Project : Project.smartwaste; // token.provider_category;
    // this.isBizzDev = true;
    this.selectedLanguage = token.language;

    this.subscription.add(this.editorService.getEditMode().subscribe(mode => {
      if (this.isBizzDev) {
        this.isInEditMode = mode;
      }
    }));

    this.findTextForm = this.fb.group({
      textToFind: ['']
    });

    const isInEditMode = sessionStorage.getItem(environment.editable);
    if (isInEditMode && isInEditMode === 'true') {
      this.isInEditMode = true;
    }

    this.subscription.add(this.fileService.getHasSelectedAFile().subscribe(data => {
      this.hasSelectedAFile = data;
    }));

    this.subscription.add(this.fileService.getEditorSub().subscribe(dm => {
      this.selectedDirectoryOrFilePath = dm.path;
      this.selectedDirectoryOrFileName = dm.name;
      this.cdr.detectChanges();
    }));
  }

  private searchForWord(ttf: TextToFind): void {
    this.searchedService.changeTextToFindSub(ttf);
    sessionStorage.setItem(environment.wordSearched, JSON.stringify(ttf));
  }
}
